import { useNavigate, useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader, Empty } from "@/components/kit";
import { PlanView } from "@/components/PlanEditor";
import useLoad from "@/lib/useLoad";

export default function MyPlans() {
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const [plans] = useLoad("/me/plans");
  const [library] = useLoad("/me/exercises");
  const type = params.get("type") || "workout";
  const byType = (t) => (plans || []).find((p) => p.type === t);
  const logDay = (plan) => (day) => nav("/app/logs", { state: { plan_id: plan.id, day } });

  return (
    <div>
      <PageHeader eyebrow="Assigned by your coach" title="My plans" testid="my-plans-title" />
      <Tabs value={type} onValueChange={(v) => setParams({ type: v })}>
        <TabsList className="bg-[#111827] border border-[#1E293B] mb-6">
          <TabsTrigger value="workout" data-testid="my-plans-tab-workout">Workout</TabsTrigger>
          <TabsTrigger value="meal" data-testid="my-plans-tab-meal">Meals</TabsTrigger>
        </TabsList>
        {["workout", "meal"].map((t) => {
          const p = byType(t);
          return (
            <TabsContent key={t} value={t}>
              {!plans ? <div className="eyebrow">Loading…</div> : !p ? <Empty text={`No ${t} plan assigned yet.`} testid={`no-${t}-plan`} /> : (
                <div data-testid={`my-${t}-plan`}>
                  <h2 className="font-display text-3xl font-bold uppercase mb-1">{p.title}</h2>
                  {p.description && <p className="text-slate-400 mb-6 max-w-2xl">{p.description}</p>}
                  <PlanView plan={p} library={library} onLogDay={t === "workout" ? logDay(p) : null} />
                </div>
              )}
            </TabsContent>
          );
        })}
      </Tabs>
    </div>
  );
}
